import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "Our Programs": "Our Programs",
      "Key Features": "Key Features",
      "About Us": "About Us",
      "CSC-IIBF Training Program": "CSC-IIBF Training Program",
      "Important Resources": "Important Resources",
      "Candidate Login": "Candidate Login",
      Language: "Language",
      "Empowering Future Banking Professionals":
        "Empowering Future Banking Professionals",
      "DRA-For Graduates": "DRA-For Graduates",
      "DRA-For Under Graduates": "DRA-For Under Graduates",
      "Enroll Now for ₹5,000 + GST (18%)": "Enroll Now for ₹5,000 + GST (18%)",
      "Enroll Now for ₹6,000 + GST (18%)": "Enroll Now for ₹6,000 + GST (18%)",
      "Enroll Now for ₹5000 + GST (18%)": "Enroll Now for ₹5000 + GST (18%)",
      "Enroll Now for ₹6000 + GST (18%)": "Enroll Now for ₹6000 + GST (18%)",
      "Enroll Now for ₹1800 + GST (18%)": "Enroll Now for ₹1800 + GST (18%)",
      "Enroll Now for ₹2700 + GST (18%)": "Enroll Now for ₹2700 + GST (18%)",
      "Going Live in April": "Going Live in April",
      "Course Duration": "Course Duration",
      "100 hours": "100 hours",
      "50 hours": "50 hours",
      "Training Completion Certificate": "Training Completion Certificate",
      "How to Register?": "How to Register?",
      "A Guide to DigiLocker": "A Guide to DigiLocker",
      "Prospectus - DRA Training (English)":
        "Prospectus - DRA Training (English)",
      "Prospectus - BC/BF Training (English)":
        "Prospectus - BC/BF Training (English)",
      "Advance Your Career":
        "Advance Your Career with the DRA Certification Program",

      "Training DRAs all over India": "Training DRAs all over India",
      "Empowering DRAs with skills and": "Empowering DRAs with skills and",
      "knowledge in India": "knowledge in India",
      "CAIIB-Certified Trainers": "CAIIB-Certified Trainers",
      "With over 20 years of rich experience in the":
        "With over 20 years of rich experience in the",
      "banking sector, we bring trusted expertise.":
        "banking sector, we bring trusted expertise.",

      "Providing comprehensive and seamless support to":
        "Providing comprehensive and seamless support to",
      "ensure effective and impactful training experiences.":
        "ensure effective and impactful training experiences.",

      "Advance Your Career with the DRA Certification Program":
        "Advance Your Career with the DRA Certification Program",
      "Advance Your Career Description":
        "Take the next step in your financial services career with CSC's Debt Recovery Agent (DRA) Certification Program. Designed to equip you with the skills, knowledge, and certification needed to excel in debt recovery, this program prepares you to represent financial institutions effectively and ethically. Gain the expertise required to thrive in the dynamic financial sector and make a meaningful impact.",

      "Transform your business by becoming a certified BC/BF":
        "Transform your business by becoming a certified BC/BF",
      "Transform Your Business Description":
        "Get certified to efficiently operate in the banking sector by completing the Business Correspondent Certification offered by CSC Academy and accredited by the Indian Institute of Banking & Finance. A BC/BF Certification provides individuals with the necessary knowledge and skills to operate as a banking correspondent, allowing them to offer basic banking services in rural areas, thus enhancing financial inclusion and providing a career opportunity in the banking sector, especially for those in underserved communities.",

      "Training Completion Description":
        "Graduates of our training receive this prestigious Course Completion Certificate, symbolizing their dedication and readiness to excel in the banking sector. This certificate serves as a testament to their expertise and commitment to advancing their careers.",

      "BC/BF Training - Basic Certification":
        "BC/BF Training - Basic Certification",
      "BC/BF Training - Advanced Certification":
        "BC/BF Training - Advanced Certification",
      "28 hours": "28 hours",
      "42 hours": "42 hours",
      "Live Online Classes + Digital Content":
        "Live Online Classes + Digital Content",
      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tamil, Telugu, Assamese",
      "About CSC Academy": "About CSC Academy",
      "Download Important Resources": "Download Important Resources",
      "Download Important Resources Description":
        "Access essential documents to support your certification journey.",
      "For Support, Contact Us": "For Support, Contact Us",
      Login: "Login",
      "CSC Academy Establishment":
        "CSC Academy was setup in 2017 that provides access to professional learning for learners of diverse backgrounds and educational needs. The CSC Academy is a not-for-profit society under the Societies Registration Act 1860 (Act 21 of 1860), as applicable to the Union of Delhi.",
      "CSC Academy Programs & Funding":
        "With its registered office in Delhi, CSC Academy is delivering various Government of India sponsored skill and education programs, in addition to courses from the private sector. Many of them are funded under Government schemes or under Corporate Social Responsibility, CSR funding.",
      "Attention Notice":
        "<div class=\"flex flex-col gap-1 md:gap-2\">\n  <p class=\"text-center\">Attention Candidates (Read Carefully): Individuals trained through CSC Academy in BC Advanced/ Basic Courses are restricted from taking exams at any CSC Center. <br/>Please select an alternative authorized exam center through IIBF Non-Member Portal.</p>\n  <p>Trained Before 26-Aug-2026 Register (BC & DRA): <span class=\"font-normal text-[12px]\">Open <a href=\"https://portal.iibf.org.in/bcbf/apply-exam\" class=\"text-solidBlue hover:underline break-all font-semibold\" target=\"_blank\" rel=\"noreferrer\">portal.iibf.org.in/bcbf/apply-exam</a>, enter your training ID, & submit to get IIBF Non-Member Portal login credentials on registered email id. | </span>Complete KYC - <span class=\"font-normal text-[12px]\">Do e-KYC via Aadhaar OTP if prompted, or proceed without KYC & start using the portal.</span></p>\n  <p>Examination (BC & DRA): <span class=\"font-normal text-[12px]\">BC Candidates can apply for the exam when the monthly window opens through IIBF Non-Member Portal, however DRA (Released/ Eligible) candidates exam applied by CSC Internally.</span></p>\n  <p>Trained After 26-Aug-2026: <span class=\"font-normal text-[12px]\">IIBF Non-Member Portal Credentials will be emailed automatically upon batch enrollment. Do not follow above registration steps. Just Log in and do your e-KYC if prompted & start using the portal.</span></p>\n  <p>IIBF Non-Member Issues: <span class=\"font-normal text-[12px]\">contact <a href=\"mailto:iibfwzmem@iibf.org.in\" class=\"text-solidBlue underline break-all font-semibold\">iibfwzmem@iibf.org.in</a>, <a href=\"mailto:je.mss4@iibf.org.in\" class=\"text-solidBlue underline break-all font-semibold\">je.mss4@iibf.org.in</a>, or <a href=\"tel:08069260710\" class=\"text-solidBlue underline break-all font-semibold\">8069260710</a> | Do not register as an Ordinary Member on IIBF | Always use an active/correct email id and mobile number in CSC registration form.</span></p>\n</div>",
    },
  },
  hi: {
    translation: {
      "Our Programs": "हमारे कार्यक्रम",
      "Key Features": "मुख्य विशेषताएँ",
      "About Us": "हमारे बारे में",
      "CSC-IIBF Training Program": "CSC-IIBF प्रशिक्षण कार्यक्रम",
      "Important Resources": "महत्वपूर्ण संसाधन",
      "Candidate Login": "उम्मीदवार लॉगिन",
      Language: "भाषा",
      "Empowering Future Banking Professionals":
        "भविष्य के बैंकिंग पेशेवरों को सशक्त बनाना",
      "DRA-For Graduates": "स्नातकों के लिए डीआरए",
      "DRA-For Under Graduates": "स्नातक से नीचे के लिए डीआरए",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + जीएसटी (18%) के लिए अभी नामांकन करें",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + जीएसटी (18%) के लिए अभी नामांकन करें",
      "Enroll Now for ₹1800 + GST (18%)":
        "₹1800 + जीएसटी (18%) के लिए अभी नामांकन करें",
      "Enroll Now for ₹2700 + GST (18%)":
        "₹2700 + जीएसटी (18%) के लिए अभी नामांकन करें",
      "Going Live in April": "अप्रैल में लाइव हो रहा है",

      "Course Duration": "कोर्स की अवधि",
      "100 hours": "100 घंटे",
      "50 hours": "50 घंटे",
      "Training Completion Certificate": "प्रशिक्षण पूरा होने का प्रमाण पत्र",
      "How to Register?": "कैसे पंजीकरण करें?",
      "A Guide to DigiLocker": "डिजिलॉकर गाइड",
      "Prospectus - DRA Training (English)":
        "प्रस्पेक्टस - डीआरए प्रशिक्षण (अंग्रेज़ी)",
      "Prospectus - BC/BF Training (English)":
        "प्रस्पेक्टस - बीसी/बीएफ प्रशिक्षण (अंग्रेज़ी)",
      "Advance Your Career":
        "डीआरए प्रमाणन कार्यक्रम के साथ अपने करियर को आगे बढ़ाएं",

      "Training DRAs all over India": "भारत भर में डीआरए प्रशिक्षण",
      "Empowering DRAs with skills and": "भारत में डीआरए को कौशल और",
      "knowledge in India": "ज्ञान से सशक्त बनाना",
      "CAIIB-Certified Trainers": "सीएआईआईबी प्रमाणित प्रशिक्षक",
      "With over 20 years of rich experience in the":
        "बैंकिंग क्षेत्र में 20 वर्षों से अधिक के समृद्ध अनुभव के साथ",
      "banking sector, we bring trusted expertise.":
        "हम विश्वसनीय विशेषज्ञता लाते हैं।",
      "Efficient Training Support": "प्रभावी प्रशिक्षण सहायता",
      "Providing comprehensive and seamless support to":
        "समग्र और निर्बाध सहायता प्रदान करना ताकि",
      "ensure effective and impactful training experiences.":
        "प्रभावी और प्रभावशाली प्रशिक्षण अनुभव सुनिश्चित किया जा सके।",
      "Advance Your Career with the DRA Certification Program":
        "डीआरए प्रमाणन कार्यक्रम के साथ अपने करियर को आगे बढ़ाएं",
      "Advance Your Career Description":
        "अपने वित्तीय सेवा करियर में अगला कदम उठाएं सीएससी के ऋण वसूली एजेंट (डीआरए) प्रमाणन कार्यक्रम के साथ। यह कार्यक्रम आपको ऋण वसूली में एक पेशेवर के रूप में उत्कृष्टता प्राप्त करने के लिए आवश्यक कौशल, ज्ञान और प्रमाणन प्रदान करता है।",

      "Transform your business by becoming a certified BC/BF":
        "अपने व्यवसाय को बीसी/बीएफ प्रमाणन के साथ बदलें",
      "Transform Your Business Description":
        "बैंकिंग क्षेत्र में प्रभावी रूप से कार्य करने के लिए प्रमाणित बनें, सीएससी अकादमी द्वारा प्रस्तुत और भारतीय बैंकिंग एवं वित्त संस्थान द्वारा मान्यता प्राप्त बिजनेस कॉरेस्पॉन्डेंट (BC/BF) प्रमाणन पूरा करके। यह प्रमाणन आपको बैंकिंग प्रतिनिधि के रूप में कार्य करने के लिए आवश्यक ज्ञान और कौशल प्रदान करता है, जिससे ग्रामीण क्षेत्रों में बैंकिंग सेवाओं को बढ़ावा दिया जा सकता है।",

      "Training Completion Description":
        "हमारे प्रशिक्षण के स्नातक इस प्रतिष्ठित पाठ्यक्रम पूर्णता प्रमाण पत्र प्राप्त करते हैं, जो उनके समर्पण और बैंकिंग क्षेत्र में उत्कृष्टता प्राप्त करने की तत्परता का प्रतीक है। यह प्रमाणपत्र उनकी विशेषज्ञता और उनके करियर को आगे बढ़ाने की प्रतिबद्धता का प्रमाण है।",

      "BC/BF Training - Basic Certification":
        "बीसी/बीएफ प्रशिक्षण - बुनियादी प्रमाणन",
      "BC/BF Training - Advanced Certification":
        "बीसी/बीएफ प्रशिक्षण - उन्नत प्रमाणन",
      "28 hours": "28 घंटे",
      "42 hours": "42 घंटे",
      "Live Online Classes + Digital Content":
        "लाइव ऑनलाइन कक्षाएं + डिजिटल सामग्री",
      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "भाषा: अंग्रेजी, हिंदी, गुजराती, मराठी, मलयालम, कन्नड़, उड़िया, बंगाली, तमिल, तेलुगु, असमिया",
      "About CSC Academy": "सीएससी अकादमी के बारे में",
      "Download Important Resources": "महत्वपूर्ण संसाधन डाउनलोड करें",
      "Download Important Resources Description":
        "अपने प्रमाणन यात्रा का समर्थन करने के लिए आवश्यक दस्तावेज़ों तक पहुँचें।",
      "For Support, Contact Us": "सहायता के लिए, हमसे संपर्क करें",
      Login: "लॉग इन",
      "CSC Academy Establishment":
        "सीएससी अकादमी की स्थापना 2017 में की गई थी, जो विभिन्न पृष्ठभूमियों और शैक्षिक आवश्यकताओं के शिक्षार्थियों के लिए व्यावसायिक शिक्षा तक पहुंच प्रदान करती है। सीएससी अकादमी एक गैर-लाभकारी संस्था है जो सोसायटी पंजीकरण अधिनियम 1860 (अधिनियम 21, 1860) के तहत पंजीकृत है, और यह दिल्ली संघ राज्य क्षेत्र पर लागू होती है।",
      "CSC Academy Programs & Funding":
        "दिल्ली में अपने पंजीकृत कार्यालय के साथ, सीएससी अकादमी वर्तमान में भारत सरकार द्वारा प्रायोजित विभिन्न कौशल और शिक्षा कार्यक्रम चला रही है, साथ ही निजी क्षेत्र के पाठ्यक्रम भी प्रदान कर रही है। इनमें से कई सरकारी योजनाओं या कॉर्पोरेट सामाजिक उत्तरदायित्व (CSR) फंडिंग के तहत वित्त पोषित हैं।",
      "Attention Notice":
        "<div class=\"flex flex-col gap-1 md:gap-2\">\n  <p class=\"text-center\">Attention Candidates (ध्यानपूर्वक पढ़ें): CSC Academy के माध्यम से BC Advanced/Basic Courses में प्रशिक्षित अभ्यर्थियों को किसी भी CSC Center से परीक्षा देने की अनुमति नहीं है। <br/>कृपया IIBF Non-Member Portal के माध्यम से किसी अन्य अधिकृत परीक्षा केंद्र का चयन करें।</p>\n  <p>26-अगस्त-2026 से पहले प्रशिक्षित अभ्यर्थी Register - <span class=\"font-normal text-[12px]\"><a href=\"https://portal.iibf.org.in/bcbf/apply-exam\" class=\"text-solidBlue hover:underline break-all font-semibold\" target=\"_blank\" rel=\"noreferrer\">portal.iibf.org.in/bcbf/apply-exam</a> खोलें, अपना Training ID दर्ज करें और Submit करें, ताकि Login Credentials आपके ईमेल पर प्राप्त हो सकें। | </span>KYC पूरा करें - <span class=\"font-normal text-[12px]\">Aadhaar OTP का उपयोग करके e-KYC पूरा करें। | </span><br/>BC Candidates - <span class=\"font-normal text-[12px]\">मासिक परीक्षा विंडो खुलने पर Non-Member Portal के माध्यम से परीक्षा के लिए आवेदन करें। | </span>DRA Candidates - <span class=\"font-normal text-[12px]\">हम आपकी ओर से परीक्षा के लिए आवेदन करेंगे, लेकिन e-KYC और 100% Zoom Training Attendance अनिवार्य है।</span></p>\n  <p>26-अगस्त-2026 के बाद प्रशिक्षित अभ्यर्थी: <span class=\"font-normal text-[12px]\">Batch Enrollment होने पर Login Credentials स्वतः ईमेल कर दिए जाएंगे। ऊपर दिए गए Registration Steps को न दोहराएँ। केवल Log in करें और अपना e-KYC व आगे की प्रक्रिया पूरी करें।</span></p>\n  <p>IIBF Non-Member से संबंधित किसी भी समस्या के लिए: <span class=\"font-normal text-[12px]\"><a href=\"mailto:iibfwzmem@iibf.org.in\" class=\"text-solidBlue underline break-all font-semibold\">iibfwzmem@iibf.org.in</a>, <a href=\"mailto:je.mss4@iibf.org.in\" class=\"text-solidBlue underline break-all font-semibold\">je.mss4@iibf.org.in</a>, या <a href=\"tel:08069260710\" class=\"text-solidBlue underline break-all font-semibold\">080 69260710</a> पर संपर्क करें।</span></p>\n  <p>NOTES: <span class=\"font-normal text-[12px]\">IIBF पर Ordinary Member के रूप में Register न करें | CSC Registration Form में हमेशा Active Email और Mobile Number का उपयोग करें।</span></p>\n</div>",
    },
  },
  bn: {
    translation: {
      "Our Programs": "আমাদের প্রোগ্রাম",
      "Key Features": "মূল বৈশিষ্ট্য",
      "About Us": "আমাদের সম্পর্কে",
      "CSC-IIBF Training Program": "CSC-IIBF প্রশিক্ষণ প্রোগ্রাম",
      "Important Resources": "গুরুত্বপূর্ণ সম্পদ",
      "Candidate Login": "প্রার্থী লগইন",
      Language: "ভাষা",
      "Empowering Future Banking Professionals":
        "ভবিষ্যৎ ব্যাংকিং পেশাদারদের ক্ষমতায়ন",
      "DRA-For Graduates": "স্নাতকদের জন্য DRA",
      "DRA-For Under Graduates": "স্নাতকোত্তরদের জন্য DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) এর জন্য এখনই নাম নথিভুক্ত করুন",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) এর জন্য এখনই নাম নথিভুক্ত করুন",
      "Going Live in April": "এপ্রিল মাসে লাইভ যাচ্ছে",
      "Course Duration": "কোর্সের সময়কাল",
      "100 hours": "১০০ ঘণ্টা",
      "50 hours": "৫০ ঘণ্টা",
      "Training Completion Certificate": "প্রশিক্ষণ সমাপ্তি শংসাপত্র",
      "How to Register?": "কিভাবে নিবন্ধন করবেন?",
      "A Guide to DigiLocker": "ডিজিলকার গাইড",
      "Prospectus - DRA Training (English)":
        "প্রসপেক্টাস - DRA প্রশিক্ষণ (ইংরেজি)",
      "Prospectus - BC/BF Training (English)":
        "প্রসপেক্টাস - BC/BF প্রশিক্ষণ (ইংরেজি)",
      "Advance Your Career":
        "আপনার ক্যারিয়ারকে এগিয়ে নিয়ে যান DRA সার্টিফিকেশন প্রোগ্রামের সাথে",

      "Training DRAs all over India": "সমস্ত ভারতে DRA প্রশিক্ষণ",
      "Empowering DRAs with skills and": "DRA-দের দক্ষতা ও জ্ঞান প্রদান",
      "knowledge in India": "ভারতে জ্ঞান প্রদান",
      "CAIIB-Certified Trainers": "CAIIB-সার্টিফায়েড প্রশিক্ষক",
      "With over 20 years of rich experience in the":
        "২০ বছরেরও বেশি সমৃদ্ধ অভিজ্ঞতা সহ",
      "banking sector, we bring trusted expertise.":
        "ব্যাংকিং সেক্টরে আমরা বিশ্বাসযোগ্য দক্ষতা নিয়ে আসছি।",

      "Providing comprehensive and seamless support to":
        "সম্পূর্ণ এবং নিরবিচ্ছিন্ন সহায়তা প্রদান",
      "ensure effective and impactful training experiences.":
        "কার্যকর এবং অর্থবহ প্রশিক্ষণের অভিজ্ঞতা নিশ্চিত করা।",

      "Advance Your Career with the DRA Certification Program":
        "DRA সার্টিফিকেশন প্রোগ্রামের সাথে আপনার ক্যারিয়ার উন্নত করুন",
      "Advance Your Career Description":
        "CSC-এর Debt Recovery Agent (DRA) সার্টিফিকেশন প্রোগ্রাম আপনাকে ঋণ পুনরুদ্ধারে দক্ষ হতে সাহায্য করার জন্য ডিজাইন করা হয়েছে। এতে প্রয়োজনীয় দক্ষতা, জ্ঞান, এবং সার্টিফিকেশন অন্তর্ভুক্ত রয়েছে, যা আপনাকে আর্থিক প্রতিষ্ঠানগুলিকে দক্ষ ও নৈতিকভাবে প্রতিনিধিত্ব করতে প্রস্তুত করে।",

      "Transform your business by becoming a certified BC/BF":
        "BC/BF সার্টিফাইড হয়ে আপনার ব্যবসাকে রূপান্তর করুন",
      "Transform Your Business Description":
        "CSC একাডেমি এবং ভারতীয় ব্যাংকিং ও ফিনান্স ইনস্টিটিউটের স্বীকৃত BC/BF সার্টিফিকেশন সম্পূর্ণ করে আপনি ব্যাংকিং সেক্টরে দক্ষতার সাথে কাজ করতে পারেন। এই সার্টিফিকেশন ব্যাংকিং প্রতিনিধি হওয়ার জন্য প্রয়োজনীয় জ্ঞান এবং দক্ষতা প্রদান করে।",

      "Training Completion Description":
        "আমাদের প্রশিক্ষণের গ্র্যাজুয়েটরা এই মর্যাদাপূর্ণ কোর্স সম্পন্নির সার্টিফিকেট পান, যা ব্যাংকিং সেক্টরে তাদের উজ্জ্বল ভবিষ্যতের স্বীকৃতি প্রদান করে।",

      "BC/BF Training - Basic Certification":
        "BC/BF প্রশিক্ষণ - মৌলিক সার্টিফিকেশন",
      "BC/BF Training - Advanced Certification":
        "BC/BF প্রশিক্ষণ - উন্নত সার্টিফিকেশন",
      "28 hours": "২৮ ঘণ্টা",
      "42 hours": "৪২ ঘণ্টা",
      "Live Online Classes + Digital Content":
        "লাইভ অনলাইন ক্লাস + ডিজিটাল সামগ্রী",
      "Languages: English, Hindi, Gujarati, Marathi, Bengali, Telugu, Kannada":
        "ভাষা: ইংরেজি, হিন্দি, গুজরাটি, মারাঠি, বাংলা, তেলুগু, কন্নড়",

      "About CSC Academy": "CSC একাডেমি সম্পর্কে",
      "Download Important Resources": "গুরুত্বপূর্ণ সম্পদ ডাউনলোড করুন",
      "Download Important Resources Description":
        "আপনার সার্টিফিকেশন যাত্রার জন্য প্রয়োজনীয় নথি অ্যাক্সেস করুন।",
      "For Support, Contact Us": "সহায়তার জন্য, আমাদের সাথে যোগাযোগ করুন",
      Login: "লগইন করুন",

      "CSC Academy Establishment":
        "CSC একাডেমি ২০১৭ সালে স্থাপিত হয়, যা বিভিন্ন পটভূমি ও শিক্ষাগত প্রয়োজনীয়তার শিক্ষার্থীদের জন্য পেশাদার শিক্ষা সরবরাহ করে। এটি একটি অলাভজনক সংস্থা যা সোসাইটি রেজিস্ট্রেশন অ্যাক্ট ১৮৬০ (অ্যাক্ট ২১, ১৮৬০) এর অধীনে নিবন্ধিত, যা দিল্লির কেন্দ্রশাসিত অঞ্চলে প্রযোজ্য।",
      "CSC Academy Programs & Funding":
        "CSC একাডেমি দিল্লিতে তার নিবন্ধিত অফিসের সাথে বর্তমানে ভারত সরকারের বিভিন্ন দক্ষতা এবং শিক্ষা প্রোগ্রাম পরিচালনা করছে। এর মধ্যে অনেক প্রোগ্রাম সরকারি প্রকল্প বা কর্পোরেট সামাজিক দায়িত্ব (CSR) তহবিলের অধীনে অর্থায়িত হয়।",
      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "ভাষা: ইংরেজি, হিন্দি, গুজরাটি, মারাঠি, মালায়ালাম, কন্নড়, ওড়িয়া, বাংলা, তামিল, তেলুগু, অসমীয়া",

      "Efficient Training Support": "কার্যকরী প্রশিক্ষণ সহায়তা",
    },
  },
  mr: {
    translation: {
      "Our Programs": "आमचे कार्यक्रम",
      "Key Features": "मुख्य वैशिष्ट्ये",
      "About Us": "आमच्याबद्दल",
      "CSC-IIBF Training Program": "CSC-IIBF प्रशिक्षण कार्यक्रम",
      "Important Resources": "महत्वाचे संसाधने",
      "Candidate Login": "उमेदवार लॉगिन",
      Language: "भाषा",
      "Empowering Future Banking Professionals":
        "भावी बँकिंग व्यावसायिकांना सक्षम करणे",
      "DRA-For Graduates": "पदवीधरांसाठी DRA",
      "DRA-For Under Graduates": "पदवीपूर्वांसाठी DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) साठी आता नोंदणी करा",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) साठी आता नोंदणी करा",
      "Going Live in April": "एप्रिलमध्ये थेट सुरू होत आहे",
      "Course Duration": "अभ्यासक्रम कालावधी",
      "100 hours": "१०० तास",
      "50 hours": "५० तास",
      "Training Completion Certificate": "प्रशिक्षण पूर्णता प्रमाणपत्र",
      "How to Register?": "नोंदणी कशी करावी?",
      "A Guide to DigiLocker": "डिजिलॉकर मार्गदर्शक",
      "Prospectus - DRA Training (English)":
        "संभाव्यता - DRA प्रशिक्षण (इंग्रजी)",
      "Prospectus - BC/BF Training (English)":
        "संभाव्यता - BC/BF प्रशिक्षण (इंग्रजी)",
      "Advance Your Career": "DRA प्रमाणन कार्यक्रमासह तुमचे करिअर पुढे चला",

      "Training DRAs all over India": "संपूर्ण भारतभर DRA प्रशिक्षण",
      "Empowering DRAs with skills and":
        "DRA ना कौशल्य आणि ज्ञानाने सक्षम करणे",
      "knowledge in India": "भारतामध्ये ज्ञान प्रदान करणे",
      "CAIIB-Certified Trainers": "CAIIB प्रमाणित प्रशिक्षक",
      "With over 20 years of rich experience in the":
        "२० वर्षांहून अधिक समृद्ध अनुभवासह",
      "banking sector, we bring trusted expertise.":
        "बँकिंग क्षेत्रात आम्ही विश्वासार्ह कौशल्य आणतो.",

      "Providing comprehensive and seamless support to":
        "व्यापक आणि अखंड समर्थन प्रदान करणे",
      "ensure effective and impactful training experiences.":
        "प्रभावी आणि परिणामकारक प्रशिक्षण अनुभव सुनिश्चित करणे.",

      "Advance Your Career with the DRA Certification Program":
        "DRA प्रमाणन कार्यक्रमासह तुमचे करिअर पुढे चला",
      "Advance Your Career Description":
        "CSC च्या Debt Recovery Agent (DRA) प्रमाणन कार्यक्रमाद्वारे तुम्ही कर्ज वसुलीमध्ये तज्ज्ञ होऊ शकता. हा कार्यक्रम आवश्यक कौशल्ये, ज्ञान आणि प्रमाणपत्र प्रदान करतो, जे तुम्हाला वित्तीय संस्थांचे प्रभावी आणि नैतिक प्रतिनिधित्व करण्यास सक्षम करेल.",

      "Transform your business by becoming a certified BC/BF":
        "प्रमाणित BC/BF बनून तुमचा व्यवसाय रूपांतरित करा",
      "Transform Your Business Description":
        "CSC अकादमी आणि भारतीय बँकिंग आणि वित्त संस्था मान्यताप्राप्त BC/BF प्रमाणपत्र पूर्ण करून तुम्ही बँकिंग क्षेत्रात कार्यक्षमतेने कार्य करू शकता. हे प्रमाणपत्र तुम्हाला बँकिंग प्रतिनिधी म्हणून आवश्यक ज्ञान आणि कौशल्ये प्रदान करते.",

      "Training Completion Description":
        "आमच्या प्रशिक्षणाचा अभ्यासक्रम पूर्ण करणारे विद्यार्थी हा प्रतिष्ठित प्रमाणपत्र प्राप्त करतात, जे त्यांच्या व्यावसायिकतेची साक्ष देते आणि त्यांना बँकिंग क्षेत्रात यशस्वी होण्यासाठी प्रेरित करते.",

      "BC/BF Training - Basic Certification":
        "BC/BF प्रशिक्षण - मूलभूत प्रमाणन",
      "BC/BF Training - Advanced Certification":
        "BC/BF प्रशिक्षण - प्रगत प्रमाणन",
      "28 hours": "२८ तास",
      "42 hours": "४२ तास",
      "Live Online Classes + Digital Content":
        "थेट ऑनलाइन वर्ग + डिजिटल सामग्री",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "भाषा: इंग्रजी, हिंदी, गुजराती, मराठी, मल्याळम, कन्नड, ओडिया, बंगाली, तमिळ, तेलगू, आसामी",

      "Efficient Training Support": "प्रभावी प्रशिक्षण समर्थन",

      "About CSC Academy": "CSC अकादमी बद्दल",
      "Download Important Resources": "महत्वाचे संसाधने डाउनलोड करा",
      "Download Important Resources Description":
        "तुमच्या प्रमाणन प्रवासासाठी आवश्यक दस्तऐवजांवर प्रवेश मिळवा.",
      "For Support, Contact Us": "मदतीसाठी, आमच्याशी संपर्क साधा",
      Login: "लॉगिन करा",

      "CSC Academy Establishment":
        "CSC अकादमी २०१७ मध्ये स्थापन झाली, जी विविध पार्श्वभूमी आणि शैक्षणिक गरजा असलेल्या विद्यार्थ्यांना व्यावसायिक शिक्षण उपलब्ध करून देते. CSC अकादमी एक ना-नफा संस्था आहे जी सोसायटी रजिस्ट्रेशन अॅक्ट १८६० (अॅक्ट २१, १८६०) अंतर्गत नोंदणीकृत आहे आणि दिल्ली केंद्रशासित प्रदेशावर लागू आहे.",
      "CSC Academy Programs & Funding":
        "CSC अकादमी सध्या दिल्लीमध्ये तिच्या नोंदणीकृत कार्यालयासह भारत सरकारद्वारे प्रायोजित विविध कौशल्य आणि शिक्षण कार्यक्रम चालवत आहे, तसेच खाजगी क्षेत्रातील अभ्यासक्रम प्रदान करत आहे. त्यापैकी अनेक सरकारी योजनांच्या किंवा कॉर्पोरेट सामाजिक उत्तरदायित्व (CSR) निधीच्या अंतर्गत वित्तपुरवठा केले जातात.",
    },
  },
  te: {
    translation: {
      "Our Programs": "మా ప్రోగ్రామ్లు",
      "Key Features": "ప్రధాన లక్షణాలు",
      "About Us": "మా గురించి",
      "CSC-IIBF Training Program": "CSC-IIBF శిక్షణ కార్యక్రమం",
      "Important Resources": "ముఖ్యమైన వనరులు",
      "Candidate Login": "అభ్యర్థి లాగిన్",
      Language: "భాష",
      "Empowering Future Banking Professionals":
        "భవిష్యత్ బ్యాంకింగ్ నిపుణులను సాధికారత కల్పించడం",
      "DRA-For Graduates": "స్నాతకుల కోసం DRA",
      "DRA-For Under Graduates": "ఇంటర్మీడియట్ విద్యార్థులకు DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) కోసం ఇప్పుడు నమోదు చేసుకోండి",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) కోసం ఇప్పుడు నమోదు చేసుకోండి",
      "Going Live in April": "ఏప్రిల్‌లో లైవ్ అవుతుంది",
      "Course Duration": "కోర్సు వ్యవధి",
      "100 hours": "100 గంటలు",
      "50 hours": "50 గంటలు",
      "Training Completion Certificate": "శిక్షణ పూర్తి ధృవీకరణపత్రం",
      "How to Register?": "ఎలా నమోదు చేయాలి?",
      "A Guide to DigiLocker": "DigiLocker గైడ్",
      "Prospectus - DRA Training (English)":
        "ప్రాస్పెక్టస్ - DRA శిక్షణ (ఆంగ్లం)",
      "Prospectus - BC/BF Training (English)":
        "ప్రాస్పెక్టస్ - BC/BF శిక్షణ (ఆంగ్లం)",
      "Advance Your Career":
        "DRA సర్టిఫికేషన్ ప్రోగ్రామ్ తో మీ కెరీర్‌ను ముందుకు తీసుకెళ్లండి",

      "Training DRAs all over India": "భారతదేశంలో అంతటా DRA ల శిక్షణ",
      "Empowering DRAs with skills and": "DRA లకు నైపుణ్యాలు మరియు",
      "knowledge in India": "భారతదేశంలో జ్ఞానం అందించడం",
      "CAIIB-Certified Trainers": "CAIIB-సర్టిఫైడ్ శిక్షకులు",
      "With over 20 years of rich experience in the":
        "20 సంవత్సరాలకు పైగా గొప్ప అనుభవంతో",
      "banking sector, we bring trusted expertise.":
        "బ్యాంకింగ్ రంగంలో మేము నమ్మదగిన నిపుణతను అందిస్తున్నాము.",

      "Providing comprehensive and seamless support to":
        "సమగ్ర మరియు సాఫల్యమైన మద్దతును అందించడం",
      "ensure effective and impactful training experiences.":
        "ప్రభావవంతమైన మరియు ప్రభావశీల శిక్షణ అనుభవాలను నిర్ధారించండి.",

      "Advance Your Career with the DRA Certification Program":
        "DRA సర్టిఫికేషన్ ప్రోగ్రామ్ తో మీ కెరీర్‌ను ముందుకు తీసుకెళ్లండి",
      "Advance Your Career Description":
        "CSC యొక్క Debt Recovery Agent (DRA) సర్టిఫికేషన్ ప్రోగ్రామ్ తో మీరు రుణ పునరుద్ధరణలో నైపుణ్యం సాధించవచ్చు. ఇది మీకు అవసరమైన నైపుణ్యాలు, జ్ఞానం మరియు ధృవీకరణను అందిస్తుంది, ఇది మీకు ఆర్థిక సంస్థలను సమర్థవంతంగా మరియు నైతికంగా ప్రాతినిధ్యం వహించడానికి సిద్ధం చేస్తుంది.",

      "Transform your business by becoming a certified BC/BF":
        "సర్టిఫైడ్ BC/BF అవ్వడం ద్వారా మీ వ్యాపారాన్ని మారుస్తుంది",
      "Transform Your Business Description":
        "CSC అకాడమీ మరియు భారత బ్యాంకింగ్ & ఫైనాన్స్ ఇన్స్టిట్యూట్ గుర్తించిన BC/BF సర్టిఫికేషన్ పూర్తిచేయడం ద్వారా మీరు బ్యాంకింగ్ రంగంలో సమర్థవంతంగా పనిచేయగలరు. ఈ ధృవీకరణ బ్యాంకింగ్ ప్రతినిధిగా పనిచేయడానికి అవసరమైన జ్ఞానం మరియు నైపుణ్యాలను అందిస్తుంది.",

      "Training Completion Description":
        "మా శిక్షణ పూర్తి చేసిన విద్యార్థులు ఈ ప్రతిష్టాత్మక కోర్సు పూర్తి ధృవీకరణ పొందుతారు, ఇది బ్యాంకింగ్ రంగంలో వారి అంకితభావాన్ని మరియు సామర్థ్యాన్ని సూచిస్తుంది.",

      "BC/BF Training - Basic Certification": "BC/BF శిక్షణ - ప్రాథమిక ధృవీకరణ",
      "BC/BF Training - Advanced Certification":
        "BC/BF శిక్షణ - ప్రోగ్రామ్డ్ ధృవీకరణ",
      "28 hours": "28 గంటలు",
      "42 hours": "42 గంటలు",
      "Live Online Classes + Digital Content":
        "లైవ్ ఆన్‌లైన్ తరగతులు + డిజిటల్ కంటెంట్",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "భాష: ఆంగ్లం, హిందీ, గుజరాతీ, మరాఠీ, మలయాళం, కన్నడ, ఒడియా, బెంగాలి, తమిళం, తెలుగు, అస్సామీస్",

      "Efficient Training Support": "సమర్థవంతమైన శిక్షణ మద్దతు",

      "About CSC Academy": "CSC అకాడమీ గురించి",
      "Download Important Resources": "ముఖ్యమైన వనరులను డౌన్లోడ్ చేయండి",
      "Download Important Resources Description":
        "మీ ధృవీకరణ ప్రయాణాన్ని మద్దతు ఇచ్చే అవసరమైన పత్రాలను యాక్సెస్ చేయండి.",
      "For Support, Contact Us": "మద్దతు కోసం, మాతో సంప్రదించండి",
      Login: "లాగిన్ చేయండి",

      "CSC Academy Establishment":
        "CSC అకాడమీ 2017లో స్థాపించబడింది, ఇది విభిన్న నేపథ్యాలు మరియు విద్యా అవసరాలను కలిగిన విద్యార్థులకు ప్రొఫెషనల్ లెర్నింగ్ అందించడానికి రూపొందించబడింది. CSC అకాడమీ అనేది లాభాపేక్ష లేని సంఘం, ఇది సొసైటీ రిజిస్ట్రేషన్ చట్టం 1860 (చట్టం 21, 1860) క్రింద నమోదైంది, ఇది ఢిల్లీలో అమలు చేయబడుతుంది.",
      "CSC Academy Programs & Funding":
        "CSC అకాడమీ ప్రస్తుతం భారత ప్రభుత్వ మద్దతు గల పలు నైపుణ్యం మరియు విద్యా ప్రోగ్రామ్‌లను అందిస్తోంది, అలాగే ప్రైవేట్ రంగ కోర్సులను అందిస్తోంది. వీటిలో అనేకవి ప్రభుత్వ పథకాలు లేదా కార్పొరేట్ సోషల్ రెస్పాన్సిబిలిటీ (CSR) నిధుల ద్వారా మద్దతు పొందుతాయి.",
    },
  },
  gu: {
    translation: {
      "Our Programs": "અમારા પ્રોગ્રામ્સ",
      "Key Features": "મુખ્ય લાક્ષણિકતાઓ",
      "About Us": "અમારા વિશે",
      "CSC-IIBF Training Program": "CSC-IIBF તાલીમ કાર્યક્રમ",
      "Important Resources": "મહત્વપૂર્ણ સંસાધનો",
      "Candidate Login": "ઉમેદવાર લોગિન",
      Language: "ભાષા",
      "Empowering Future Banking Professionals":
        "ભાવિ બેંકિંગ વ્યવસાયિકોને સશક્ત બનાવવું",
      "DRA-For Graduates": "સ્નાતકો માટે DRA",
      "DRA-For Under Graduates": "સ્નાતક પૂર્વના વિદ્યાર્થીઓ માટે DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) માટે હવે નોંધણી કરો",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) માટે હવે નોંધણી કરો",
      "Going Live in April": "એપ્રિલમાં લાઈવ થઈ રહ્યું છે",
      "Course Duration": "અભ્યાસક્રમ અવધિ",
      "100 hours": "100 કલાક",
      "50 hours": "50 કલાક",
      "Training Completion Certificate": "પ્રશિક્ષણ પૂર્ણતા પ્રમાણપત્ર",
      "How to Register?": "કેવી રીતે નોંધણી કરશો?",
      "A Guide to DigiLocker": "DigiLocker માટે માર્ગદર્શિકા",
      "Prospectus - DRA Training (English)":
        "પ્રોસ્પેક્ટસ - DRA તાલીમ (અંગ્રેજી)",
      "Prospectus - BC/BF Training (English)":
        "પ્રોસ્પેક્ટસ - BC/BF તાલીમ (અંગ્રેજી)",
      "Advance Your Career":
        "DRA પ્રમાણપત્ર કાર્યક્રમ સાથે તમારું કારકિર્દી આગળ વધારો",

      "Training DRAs all over India": "સમગ્ર ભારતમાં DRA ટ્રેનિંગ",
      "Empowering DRAs with skills and":
        "DRA ને કુશળતા અને જ્ઞાનથી સશક્ત બનાવવું",
      "knowledge in India": "ભારતમાં જ્ઞાન પૂરું પાડવું",
      "CAIIB-Certified Trainers": "CAIIB પ્રમાણિત તાલીમદાતા",
      "With over 20 years of rich experience in the":
        "20 વર્ષથી વધુનો સમૃદ્ધ અનુભવ",
      "banking sector, we bring trusted expertise.":
        "બેંકિંગ ક્ષેત્રમાં, અમે વિશ્વસનીય નિષ્ણાતી લાવીએ છીએ.",

      "Providing comprehensive and seamless support to":
        "સંપૂર્ણ અને સરળ ટેકો પૂરો પાડવો",
      "ensure effective and impactful training experiences.":
        "અસરકારક અને અસરશીલ તાલીમ અનુભવ સુનિશ્ચિત કરવો.",

      "Advance Your Career with the DRA Certification Program":
        "DRA પ્રમાણપત્ર કાર્યક્રમ સાથે તમારું કારકિર્દી આગળ વધારો",
      "Advance Your Career Description":
        "CSC ની Debt Recovery Agent (DRA) પ્રમાણપત્ર કાર્યક્રમ સાથે તમે લોન પુનઃપ્રાપ્તિમાં કુશળતા મેળવી શકો. આ કાર્યક્રમ જરૂરી કુશળતા, જ્ઞાન અને પ્રમાણપત્ર પૂરૂં પાડે છે, જે તમને નૈતિક અને અસરકારક રીતે નાણાકીય સંસ્થાઓનું પ્રતિનિધિત્વ કરવામાં મદદ કરશે.",

      "Transform your business by becoming a certified BC/BF":
        "પ્રમાણિત BC/BF બનીને તમારું વ્યાવસાયિક જીવન પરિવર્તન કરો",
      "Transform Your Business Description":
        "CSC અકાદમી અને ભારતીય બેંકિંગ અને નાણાં સંસ્થા માન્યતા પ્રાપ્ત BC/BF પ્રમાણપત્ર પૂર્ણ કરીને, તમે બેંકિંગ ક્ષેત્રમાં કુશળતાપૂર્વક કાર્ય કરી શકો. આ પ્રમાણપત્ર બેંકિંગ પ્રતિનિધિ તરીકે જરૂરી જ્ઞાન અને કુશળતા પ્રદાન કરે છે.",

      "Training Completion Description":
        "અમારા તાલીમનો અભ્યાસક્રમ પૂર્ણ કરનારા વિદ્યાર્થીઓ આ પ્રતિષ્ઠિત પ્રમાણપત્ર મેળવે છે, જે બેંકિંગ ક્ષેત્રમાં તેમની નિષ્ઠા અને ક્ષમતાને પ્રતિબિંબિત કરે છે.",

      "BC/BF Training - Basic Certification": "BC/BF તાલીમ - મૂળભૂત પ્રમાણપત્ર",
      "BC/BF Training - Advanced Certification":
        "BC/BF તાલીમ - ઉચ્ચ પ્રમાણપત્ર",
      "28 hours": "28 કલાક",
      "42 hours": "42 કલાક",
      "Live Online Classes + Digital Content":
        "લાઇવ ઓનલાઇન વર્ગો + ડિજિટલ સામગ્રી",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "ભાષા: અંગ્રેજી, હિન્દી, ગુજરાતી, મરાઠી, મલયાલમ, કન્નડ, ઓડિયા, બંગાળી, તમિળ, તેલુગુ, આસામિયા",

      "Efficient Training Support": "કાર્યક્ષમ તાલીમ સહાય",

      "About CSC Academy": "CSC અકાદમી વિશે",
      "Download Important Resources": "મહત્વપૂર્ણ સંસાધનો ડાઉનલોડ કરો",
      "Download Important Resources Description":
        "તમારા પ્રમાણપત્ર પ્રવાસ માટે જરૂરી દસ્તાવેજોનો ઍક્સેસ મેળવો.",
      "For Support, Contact Us": "સહાય માટે, અમારો સંપર્ક કરો",
      Login: "લૉગિન કરો",

      "CSC Academy Establishment":
        "CSC અકાદમી 2017 માં સ્થાપિત કરવામાં આવી હતી, જે વિવિધ પૃષ્ઠભૂમિ અને શૈક્ષણિક જરૂરિયાતો ધરાવતા વિદ્યાર્થીઓ માટે વ્યવસાયિક શિક્ષણ પ્રદાન કરે છે. CSC અકાદમી એ એક બિન-લાભકારી સંસ્થા છે, જે સોસાયટી રજિસ્ટ્રેશન એક્ટ 1860 (એક્ટ 21, 1860) હેઠળ નોંધણી થયેલી છે, જે દિલ્હીમાં લાગુ થાય છે.",
      "CSC Academy Programs & Funding":
        "CSC અકાદમી હાલમાં ભારતીય સરકાર પ્રાયોજિત વિવિધ કુશળતા અને શિક્ષણ કાર્યક્રમો પ્રદાન કરે છે, તેમજ ખાનગી ક્ષેત્રના અભ્યાસક્રમો પૂરા પાડે છે. તે પૈકી ઘણા સરકારી યોજનાઓ અથવા કોર્પોરેટ સોશિયલ રિસ્પોન્સિબિલિટી (CSR) નાણાકીય સહાય હેઠળ ભંડોળ મેળવે છે.",
    },
  },
  kn: {
    translation: {
      "Our Programs": "ನಮ್ಮ ಕಾರ್ಯಕ್ರಮಗಳು",
      "Key Features": "ಮುಖ್ಯ ವೈಶಿಷ್ಟ್ಯಗಳು",
      "About Us": "ನಮ್ಮ ಬಗ್ಗೆ",
      "CSC-IIBF Training Program": "CSC-IIBF ತರಬೇತಿ ಕಾರ್ಯಕ್ರಮ",
      "Important Resources": "ಪ್ರಮುಖ ಸಂಪತ್ತುಗಳು",
      "Candidate Login": "ಅಭ್ಯರ್ಥಿ ಲಾಗಿನ್",
      Language: "ಭಾಷೆ",
      "Empowering Future Banking Professionals":
        "ಭವಿಷ್ಯದ ಬ್ಯಾಂಕಿಂಗ್ ವೃತ್ತಿಪರರನ್ನು ಶಕ್ತಿಗೊಳಿಸುವುದು",
      "DRA-For Graduates": "ಪದವೀಧರರಿಗೆ DRA",
      "DRA-For Under Graduates": "ಪದವಿ ಪೂರ್ವ ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) ಗಾಗಿ ಈಗ ನೋಂದಾಯಿಸಿ",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) ಗಾಗಿ ಈಗ ನೋಂದಾಯಿಸಿ",
      "Going Live in April": "ಏಪ್ರಿಲ್‌ನಲ್ಲಿ ಲೈವ್ ಆಗುತ್ತಿದೆ",
      "Course Duration": "ಪಠ್ಯಕ್ರಮ ಅವಧಿ",
      "100 hours": "100 ಗಂಟೆ",
      "50 hours": "50 ಗಂಟೆ",
      "Training Completion Certificate": "ತರಬೇತಿ ಪೂರ್ಣಗೊಂಡ ಪ್ರಮಾಣಪತ್ರ",
      "How to Register?": "ನೋಂದಾಯಿಸುವುದು ಹೇಗೆ?",
      "A Guide to DigiLocker": "DigiLocker ಮಾರ್ಗದರ್ಶಿ",
      "Prospectus - DRA Training (English)":
        "ಪ್ರಾಸ್ಪೆಕ್ಟಸ್ - DRA ತರಬೇತಿ (ಇಂಗ್ಲಿಷ್)",
      "Prospectus - BC/BF Training (English)":
        "ಪ್ರಾಸ್ಪೆಕ್ಟಸ್ - BC/BF ತರಬೇತಿ (ಇಂಗ್ಲಿಷ್)",
      "Advance Your Career":
        "DRA ಪ್ರಮಾಣೀಕರಣ ಕಾರ್ಯಕ್ರಮದೊಂದಿಗೆ ನಿಮ್ಮ ವೃತ್ತಿಯನ್ನು ಮುಂದುವರಿಸಿ",

      "Training DRAs all over India": "ಭಾರತದಾದ್ಯಂತ DRA ಗಳಿಗೆ ತರಬೇತಿ",
      "Empowering DRAs with skills and": "DRA ಗಳಿಗೆ ಕೌಶಲ್ಯ ಮತ್ತು",
      "knowledge in India": "ಭಾರತದಲ್ಲಿ ಜ್ಞಾನ ಒದಗಿಸಲಾಗುತ್ತಿದೆ",
      "CAIIB-Certified Trainers": "CAIIB ಪ್ರಮಾಣೀಕೃತ ತರಬೇತುದಾರರು",
      "With over 20 years of rich experience in the":
        "20 ವರ್ಷಗಳಷ್ಟು ಸಮೃದ್ಧ ಅನುಭವದೊಂದಿಗೆ",
      "banking sector, we bring trusted expertise.":
        "ಬ್ಯಾಂಕಿಂಗ್ ಕ್ಷೇತ್ರದಲ್ಲಿ, ನಾವು ವಿಶ್ವಾಸಾರ್ಹ ಪರಿಣಿತರನ್ನು ತರುತ್ತೇವೆ.",

      "Providing comprehensive and seamless support to":
        "ಸಂಪೂರ್ಣ ಮತ್ತು ನಿರ್ಬಾಧ ಬೆಂಬಲ ಒದಗಿಸುವುದು",
      "ensure effective and impactful training experiences.":
        "ಪ್ರಭಾವಶೀಲ ಮತ್ತು ಪರಿಣಾಮಕಾರಿ ತರಬೇತಿ ಅನುಭವವನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",

      "Advance Your Career with the DRA Certification Program":
        "DRA ಪ್ರಮಾಣೀಕರಣ ಕಾರ್ಯಕ್ರಮದೊಂದಿಗೆ ನಿಮ್ಮ ವೃತ್ತಿಯನ್ನು ಮುಂದುವರಿಸಿ",
      "Advance Your Career Description":
        "CSC ನ Debt Recovery Agent (DRA) ಪ್ರಮಾಣೀಕರಣ ಕಾರ್ಯಕ್ರಮವು ನಿಮಗೆ ಸಾಲ ಮರುಪಾವತಿ ಕ್ಷೇತ್ರದಲ್ಲಿ ನಿಪುಣರಾಗಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ. ಇದು ಅಗತ್ಯವಿರುವ ಕೌಶಲ್ಯಗಳು, ಜ್ಞಾನ ಮತ್ತು ಪ್ರಮಾಣಪತ್ರವನ್ನು ಒದಗಿಸುತ್ತದೆ, ಇದು ನಿಮಗೆ ಹಣಕಾಸು ಸಂಸ್ಥೆಗಳನ್ನು ಸಮರ್ಥವಾಗಿ ಮತ್ತು ನೀತಿಪಾಲಕರಾಗಿ ಪ್ರತಿನಿಧಿಸಲು ಸಿದ್ಧಪಡಿಸುತ್ತದೆ.",

      "Transform your business by becoming a certified BC/BF":
        "ಪ್ರಮಾಣೀಕೃತ BC/BF ಆಗಿ ನಿಮ್ಮ ವ್ಯವಹಾರವನ್ನು ಪರಿವರ್ತಿಸಿ",
      "Transform Your Business Description":
        "CSC ಅಕಾಡೆಮಿ ಮತ್ತು ಭಾರತೀಯ ಬ್ಯಾಂಕಿಂಗ್ ಮತ್ತು ಹಣಕಾಸು ಸಂಸ್ಥೆ ಅನುಮೋದಿಸಿದ BC/BF ಪ್ರಮಾಣಪತ್ರವನ್ನು ಪೂರ್ಣಗೊಳಿಸುವ ಮೂಲಕ, ನೀವು ಬ್ಯಾಂಕಿಂಗ್ ಕ್ಷೇತ್ರದಲ್ಲಿ ಸಮರ್ಥವಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸಬಹುದು. ಈ ಪ್ರಮಾಣಪತ್ರವು ಬ್ಯಾಂಕಿಂಗ್ ಪ್ರತಿನಿಧಿಯಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸಲು ಅಗತ್ಯವಿರುವ ಜ್ಞಾನ ಮತ್ತು ಕೌಶಲ್ಯಗಳನ್ನು ಒದಗಿಸುತ್ತದೆ.",

      "Training Completion Description":
        "ನಮ್ಮ ತರಬೇತಿ ಪೂರ್ಣಗೊಳಿಸಿದ ವಿದ್ಯಾರ್ಥಿಗಳು ಈ ಪ್ರತಿಷ್ಠಿತ ಕೋರ್ಸ್ ಪೂರ್ಣಗೊಳಿಸಿದ ಪ್ರಮಾಣಪತ್ರವನ್ನು ಪಡೆಯುತ್ತಾರೆ, ಇದು ಅವರ ವೃತ್ತಿಪರತೆಗೆ ಸಾಕ್ಷಿಯಾಗಿದೆ ಮತ್ತು ಬ್ಯಾಂಕಿಂಗ್ ಕ್ಷೇತ್ರದಲ್ಲಿ ಯಶಸ್ವಿಯಾಗಿ ಮುಂದೆ ಸಾಗಲು ಪ್ರೇರೇಪಿಸುತ್ತದೆ.",

      "BC/BF Training - Basic Certification":
        "BC/BF ತರಬೇತಿ - ಮೂಲಭೂತ ಪ್ರಮಾಣಪತ್ರ",
      "BC/BF Training - Advanced Certification":
        "BC/BF ತರಬೇತಿ - ಉನ್ನತ ಪ್ರಮಾಣಪತ್ರ",
      "28 hours": "28 ಗಂಟೆ",
      "42 hours": "42 ಗಂಟೆ",
      "Live Online Classes + Digital Content":
        "ಲೈವ್ ಆನ್‌ಲೈನ್ ತರಗತಿಗಳು + ಡಿಜಿಟಲ್ ವಿಷಯ",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "ಭಾಷೆ: ಇಂಗ್ಲಿಷ್, ಹಿಂದಿ, ಗುಜರಾತಿ, ಮರಾಠಿ, ಮಲಯಾಳಂ, ಕನ್ನಡ, ಒಡಿಯಾ, ಬೆಂಗಾಳಿ, ತಮಿಳು, ತೆಲುಗು, ಅಸ್ಸಾಮೀಸ್",

      "Efficient Training Support": "ಸಮರ್ಥ ತರಬೇತಿ ಬೆಂಬಲ",

      "About CSC Academy": "CSC ಅಕಾಡೆಮಿ ಬಗ್ಗೆ",
      "Download Important Resources": "ಪ್ರಮುಖ ಸಂಪತ್ತನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
      "Download Important Resources Description":
        "ನಿಮ್ಮ ಪ್ರಮಾಣೀಕರಣ ಪ್ರಯಾಣವನ್ನು ಬೆಂಬಲಿಸಲು ಅಗತ್ಯವಿರುವ ದಾಖಲೆಗಳನ್ನು ಪ್ರವೇಶಿಸಿ.",
      "For Support, Contact Us": "ಬೆಂಬಲಕ್ಕಾಗಿ, ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
      Login: "ಲಾಗಿನ್ ಮಾಡಿ",

      "CSC Academy Establishment":
        "CSC ಅಕಾಡೆಮಿ 2017 ರಲ್ಲಿ ಸ್ಥಾಪಿಸಲಾಯಿತು, ಇದು ವಿವಿಧ ಹಿನ್ನೆಲೆಗಳು ಮತ್ತು ಶೈಕ್ಷಣಿಕ ಅಗತ್ಯಗಳನ್ನು ಹೊಂದಿರುವ ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ವೃತ್ತಿಪರ ಕಲಿಕೆಯನ್ನು ಪ್ರವೇಶಿಸಲು ಅವಕಾಶ ಒದಗಿಸುತ್ತದೆ. CSC ಅಕಾಡೆಮಿ ನಿಷ್ಪ್ರಯೋಜಕ ಸಂಸ್ಥೆಯಾಗಿದೆ, ಇದು ಸೊಸೈಟಿ ರಿಜಿಸ್ಟ್ರೇಶನ್ ಆಕ್ಟ್ 1860 (ಆಕ್ಟ್ 21, 1860) ಅಡಿಯಲ್ಲಿ ನೋಂದಾಯಿಸಲಾಗಿದೆ, ಇದು ದೆಹಲಿ ಕೇಂದ್ರಾಡಳಿತ ಪ್ರದೇಶಕ್ಕೆ ಅನ್ವಯಿಸುತ್ತದೆ.",
      "CSC Academy Programs & Funding":
        "CSC ಅಕಾಡೆಮಿ ಪ್ರಸ್ತುತ ಭಾರತ ಸರ್ಕಾರವು ಬೆಂಬಲಿತ ಹಲವು ಕೌಶಲ್ಯ ಮತ್ತು ಶಿಕ್ಷಣ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು, ಹಾಗು ಖಾಸಗಿ ವಲಯದ ಕೋರ್ಸುಗಳನ್ನು ಒದಗಿಸುತ್ತಿದೆ. ಇವುಗಳಲ್ಲಿ ಹಲವಾರು ಸರಕಾರದ ಯೋಜನೆಗಳು ಅಥವಾ ಕಾರ್ಪೊರೇಟ್ ಸೋಷಿಯಲ್ ರೆಸ್ಪಾನ್ಸಿಬಿಲಿಟಿ (CSR) ಹಣಕಾಸು ಮೌಲ್ಯಯುತವಾಗಿವೆ.",
    },
  },
  ml: {
    translation: {
      "Our Programs": "ഞങ്ങളുടെ പ്രോഗ്രാമുകൾ",
      "Key Features": "പ്രധാന സവിശേഷതകൾ",
      "About Us": "ഞങ്ങളേക്കുറിച്ച്",
      "CSC-IIBF Training Program": "CSC-IIBF പരിശീലന പരിപാടി",
      "Important Resources": "പ്രധാനമായ വിഭവങ്ങൾ",
      "Candidate Login": "അഭ്യർഥി ലോഗിൻ",
      Language: "ഭാഷ",
      "Empowering Future Banking Professionals":
        "ഭാവിയിലെ ബാങ്കിംഗ് വിദഗ്ധരെ ശക്തമാക്കുക",
      "DRA-For Graduates": "ബിരുദധാരികൾക്കായുള്ള DRA",
      "DRA-For Under Graduates": "ബിരുദം നേടാത്തവർക്കായുള്ള DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) ൽ ഇപ്പോൾ രജിസ്റ്റർ ചെയ്യുക",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) ൽ ഇപ്പോൾ രജിസ്റ്റർ ചെയ്യുക",
      "Going Live in April": "ഏപ്രിൽ ayında ലൈവ് പോകുന്നു",
      "Course Duration": "കോഴ്സ് ദൈർഘ്യം",
      "100 hours": "100 മണിക്കൂർ",
      "50 hours": "50 മണിക്കൂർ",
      "Training Completion Certificate":
        "പരിശീലനം പൂർത്തിയാക്കിയതിന് സർട്ടിഫിക്കറ്റ്",
      "How to Register?": "എങ്ങനെ രജിസ്റ്റർ ചെയ്യാം?",
      "A Guide to DigiLocker": "DigiLocker ഗൈഡ്",
      "Prospectus - DRA Training (English)":
        "പ്രോസ്പെക്റ്റസ് - DRA പരിശീലനം (ഇംഗ്ലീഷ്)",
      "Prospectus - BC/BF Training (English)":
        "പ്രോസ്പെക്റ്റസ് - BC/BF പരിശീലനം (ഇംഗ്ലീഷ്)",
      "Advance Your Career":
        "DRA സർട്ടിഫിക്കേഷൻ പ്രോഗ്രാമിനൊപ്പം നിങ്ങളുടെ കരിയർ മുന്നോട്ട് നയിക്കുക",

      "Training DRAs all over India": "ഇന്ത്യയൊട്ടാകെ DRA പരിശീലനം",
      "Empowering DRAs with skills and": "DRA കൾക്ക് കഴിവുകളും",
      "knowledge in India": "ഇന്ത്യയിലെ അറിവ് നൽകുന്നു",
      "CAIIB-Certified Trainers": "CAIIB- സർട്ടിഫൈഡ് പരിശീലകമാർ",
      "With over 20 years of rich experience in the":
        "20 വർഷത്തിലധികം സമൃദ്ധമായ അനുഭവത്തോടെ",
      "banking sector, we bring trusted expertise.":
        "ബാങ്കിംഗ് മേഖലയിലേക്ക് ഞങ്ങൾ വിശ്വാസയോഗ്യമായ വിദഗ്ദ്ധത നൽകുന്നു.",

      "Providing comprehensive and seamless support to":
        "സമഗ്രവും തടസ്സരഹിതവുമായ പിന്തുണ നൽകുന്നു",
      "ensure effective and impactful training experiences.":
        "പ്രഭാവശാലിയുമായ പരിശീലന അനുഭവങ്ങൾ ഉറപ്പാക്കുന്നു.",

      "Advance Your Career with the DRA Certification Program":
        "DRA സർട്ടിഫിക്കേഷൻ പ്രോഗ്രാമിനൊപ്പം നിങ്ങളുടെ കരിയർ മുന്നോട്ട് നയിക്കുക",
      "Advance Your Career Description":
        "CSC യുടെ Debt Recovery Agent (DRA) സർട്ടിഫിക്കേഷൻ പ്രോഗ്രാം നിങ്ങളെ കടബാധ്യത വീണ്ടെടുക്കൽ രംഗത്ത് പ്രൊഫഷണലായി വളരാൻ സഹായിക്കുന്നു. ഈ പ്രോഗ്രാം ആവശ്യമായ കഴിവുകളും അറിവുകളും സർട്ടിഫിക്കേഷനും നൽകുന്നു, ഇത് നിങ്ങൾക്ക് ധനകാര്യ സ്ഥാപനങ്ങളെ ഫലപ്രദമായി പ്രതിനിധീകരിക്കാൻ സഹായിക്കും.",

      "Transform your business by becoming a certified BC/BF":
        "സർട്ടിഫൈഡ് BC/BF ആകുകയിലൂടെ നിങ്ങളുടെ ബിസിനസിനെ മാറ്റി ഉയർത്തുക",
      "Transform Your Business Description":
        "CSC അക്കാദമിയും ഇന്ത്യൻ ബാങ്കിംഗ് & ഫിനാൻസ് ഇൻസ്റ്റിറ്റ്യൂട്ടും അംഗീകരിച്ച BC/BF സർട്ടിഫിക്കേഷൻ പൂർത്തിയാക്കുന്നതിലൂടെ, നിങ്ങൾക്ക് ബാങ്കിംഗ് മേഖലയിൽ ഫലപ്രദമായി പ്രവർത്തിക്കാം. ഈ സർട്ടിഫിക്കേഷൻ ബാങ്കിംഗ് പ്രതിനിധിയായി പ്രവർത്തിക്കാൻ ആവശ്യമായ അറിവും കഴിവുകളും നൽകുന്നു.",

      "Training Completion Description":
        "ഞങ്ങളുടെ പരിശീലനം പൂർത്തിയാക്കിയ വിദ്യാർത്ഥികൾ ഈ പ്രഥിഷ്ഠിത കോഴ്സ് പൂർത്തിയാക്കിയതിനുള്ള സർട്ടിഫിക്കേഷൻ നേടും, ഇത് അവരുടെ കരിയറിലെ പ്രതിബദ്ധതയും പ്രോത്സാഹനവുമാണ്.",

      "BC/BF Training - Basic Certification":
        "BC/BF പരിശീലനം - അടിസ്ഥാന സർട്ടിഫിക്കേഷൻ",
      "BC/BF Training - Advanced Certification":
        "BC/BF പരിശീലനം - പുരോഗതിയിലുളള സർട്ടിഫിക്കേഷൻ",
      "28 hours": "28 മണിക്കൂർ",
      "42 hours": "42 മണിക്കൂർ",
      "Live Online Classes + Digital Content":
        "തത്സമയ ഓൺലൈൻ ക്ലാസുകൾ + ഡിജിറ്റൽ ഉള്ളടക്കം",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "ഭാഷ: ഇംഗ്ലീഷ്, ഹിന്ദി, ഗുജറാത്തി, മറാത്തി, മലയാളം, കന്നട, ഒറിയ, ബംഗാളി, തമിഴ്, തെലുങ്ക്, അസ്സാമീസ്",

      "Efficient Training Support": "സമർത്ഥമായ പരിശീലന പിന്തുണ",

      "About CSC Academy": "CSC അക്കാദമി കുറിച്ച്",
      "Download Important Resources": "പ്രധാന വിഭവങ്ങൾ ഡൗൺലോഡ് ചെയ്യുക",
      "Download Important Resources Description":
        "നിങ്ങളുടെ സർട്ടിഫിക്കേഷൻ യാത്രയെ പിന്തുണയ്ക്കാനാവശ്യമായ രേഖകൾ ആക്സസ് ചെയ്യുക.",
      "For Support, Contact Us": "പിന്തുണയ്ക്കാനായി, ഞങ്ങളുമായി ബന്ധപ്പെടുക",
      Login: "ലോഗിൻ ചെയ്യുക",

      "CSC Academy Establishment":
        "CSC അക്കാദമി 2017 ൽ സ്ഥാപിതമായി, വിവിധ പശ്ചാത്തലങ്ങൾക്കും വിദ്യാഭ്യാസ ആവശ്യങ്ങൾക്കുമുള്ള വിദ്യാർത്ഥികൾക്ക് പ്രൊഫഷണൽ ലേണിംഗ് ആക്‌സസ് നൽകുന്നു. CSC അക്കാദമി ഒരു ലാഭരഹിത സമൂഹമാണ്, ഇത് സൊസൈറ്റി രജിസ്ട്രേഷൻ ആക്റ്റ് 1860 (ആക്റ്റ് 21, 1860) പ്രകാരം രജിസ്റ്റർ ചെയ്യപ്പെട്ടിരിക്കുന്നു, ഇത് ദില്ലിയിലെ യൂണിയൻ പ്രദേശത്ത് ബാധകമാണ്.",
      "CSC Academy Programs & Funding":
        "CSC അക്കാദമി നിലവിൽ ദില്ലിയിലെ അവരുടെ രജിസ്റ്റർ ചെയ്ത ഓഫീസിന്റെ കീഴിൽ, ഇന്ത്യൻ ഗവൺമെൻറ് പിന്തുണയുള്ള വിവിധ നൈപുണ്യപരവും വിദ്യാഭ്യാസപരവുമായ പദ്ധതികൾ നടപ്പിലാക്കുന്നു, കൂടാതെ സ്വകാര്യ മേഖലയിലെ കോഴ്സുകളും നൽകുന്നു. ഇതിൽ പലതും സർക്കാർ പദ്ധതികൾക്കോ അല്ലെങ്കിൽ കോർപ്പറേറ്റ് സോഷ്യൽ റിസ്പോൺസിബിലിറ്റി (CSR) ഫണ്ടിങ്ങിനോടു അനുബന്ധിച്ചാണുള്ളത്.",
    },
  },
  ta: {
    translation: {
      "Our Programs": "எங்கள் நிகழ்ச்சிகள்",
      "Key Features": "முக்கிய அம்சங்கள்",
      "About Us": "எங்களை பற்றி",
      "CSC-IIBF Training Program": "CSC-IIBF பயிற்சி திட்டம்",
      "Important Resources": "முக்கிய வளங்கள்",
      "Candidate Login": "வேட்பாளர் உள்நுழைவு",
      Language: "மொழி",
      "Empowering Future Banking Professionals":
        "எதிர்கால வங்கி தொழிலாளர்களை அதிகாரப்படுத்துதல்",
      "DRA-For Graduates": "பட்டதாரிகளுக்கான DRA",
      "DRA-For Under Graduates": "பட்டப்படிக்கைக்கு முன் உள்ளவர்களுக்கான DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%)க்கு இப்போது பதிவு செய்யுங்கள்",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%)க்கு இப்போது பதிவு செய்யுங்கள்",
      "Going Live in April": "ஏப்ரல் மாதத்தில் நேரலை ஆகிறது",
      "Course Duration": "பாடநெறி கால அளவு",
      "100 hours": "100 மணி நேரம்",
      "50 hours": "50 மணி நேரம்",
      "Training Completion Certificate": "பயிற்சி நிறைவு சான்றிதழ்",
      "How to Register?": "எப்படி பதிவு செய்வது?",
      "A Guide to DigiLocker": "DigiLocker வழிகாட்டி",
      "Prospectus - DRA Training (English)":
        "பிராஸ்பெக்டஸ் - DRA பயிற்சி (ஆங்கிலம்)",
      "Prospectus - BC/BF Training (English)":
        "பிராஸ்பெக்டஸ் - BC/BF பயிற்சி (ஆங்கிலம்)",
      "Advance Your Career":
        "DRA சான்றிதழ் திட்டத்துடன் உங்கள் தொழில் முன்னேற்றுங்கள்",

      "Training DRAs all over India": "இந்திய முழுவதும் DRAகளுக்கு பயிற்சி",
      "Empowering DRAs with skills and": "DRAகளை திறன்கள் மற்றும்",
      "knowledge in India": "இந்தியாவில் அறிவுடன் அதிகாரப்படுத்துதல்",
      "CAIIB-Certified Trainers": "CAIIB-சான்றளிக்கப்பட்ட பயிற்சியாளர்கள்",
      "With over 20 years of rich experience in the":
        "20 ஆண்டுகளுக்கு மேல் பன்முகமான அனுபவத்துடன்",
      "banking sector, we bring trusted expertise.":
        "வங்கி துறையில், நாங்கள் நம்பகமான நிபுணத்துவத்தை வழங்குகிறோம்.",

      "Providing comprehensive and seamless support to":
        "முழுமையான மற்றும் தடையில்லா ஆதரவை வழங்குதல்",
      "ensure effective and impactful training experiences.":
        "தோல்வியற்ற மற்றும் பயனுள்ள பயிற்சி அனுபவத்தை உறுதி செய்யுங்கள்.",

      "Advance Your Career with the DRA Certification Program":
        "DRA சான்றிதழ் திட்டத்துடன் உங்கள் தொழில் முன்னேற்றுங்கள்",
      "Advance Your Career Description":
        "CSCயின் Debt Recovery Agent (DRA) சான்றிதழ் திட்டம் உங்களை கடன் மீட்பு துறையில் ஒரு நிபுணராக உருவாக்க வடிவமைக்கப்பட்டுள்ளது. இது உங்களுக்கு தேவையான திறன்கள், அறிவு மற்றும் சான்றிதழ்களை வழங்குகிறது, இது உங்களை நிதி நிறுவனங்களை நேர்மையாகவும் திறம்படவும் பிரதிநிதித்துவப்படுத்த உதவுகிறது.",

      "Transform your business by becoming a certified BC/BF":
        "சான்றளிக்கப்பட்ட BC/BF ஆகி உங்கள் வணிகத்தை மேம்படுத்துங்கள்",
      "Transform Your Business Description":
        "CSC அகாடமி மற்றும் இந்திய வங்கி மற்றும் நிதி நிறுவனம் அங்கீகரித்த BC/BF சான்றிதழை முடித்து வைப்பதன் மூலம், நீங்கள் வங்கி துறையில் திறம்பட செயல்படலாம். இந்த சான்றிதழ் வங்கி பிரதிநிதியாக செயல்பட தேவையான அறிவும் திறன்களும் வழங்குகிறது.",

      "Training Completion Description":
        "எங்கள் பயிற்சியை முடித்த பட்டதாரிகள் இந்த சிறப்பு பாடநெறி முடிவு சான்றிதழைப் பெறுகிறார்கள், இது வங்கி துறையில் அவர்களின் அர்ப்பணிப்பையும் திறமையையும் காட்டுகிறது.",

      "BC/BF Training - Basic Certification":
        "BC/BF பயிற்சி - அடிப்படை சான்றிதழ்",
      "BC/BF Training - Advanced Certification":
        "BC/BF பயிற்சி - மேம்பட்ட சான்றிதழ்",
      "28 hours": "28 மணி நேரம்",
      "42 hours": "42 மணி நேரம்",
      "Live Online Classes + Digital Content":
        "நேரடி ஆன்லைன் வகுப்புகள் + டிஜிட்டல் உள்ளடக்கம்",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "மொழி: ஆங்கிலம், ஹிந்தி, குஜராத்தி, மராத்தி, மலையாளம், கன்னடம், ஒரியா, பெங்காலி, தமிழ், தெலுங்கு, அசாமி",

      "Efficient Training Support": "திறமையான பயிற்சி ஆதரவு",

      "About CSC Academy": "CSC அகாடமி பற்றி",
      "Download Important Resources": "முக்கிய வளங்களைப் பதிவிறக்கவும்",
      "Download Important Resources Description":
        "உங்கள் சான்றிதழ் பயணத்தை ஆதரிக்க தேவையான ஆவணங்களை அணுகவும்.",
      "For Support, Contact Us": "ஆதரவிற்கு, எங்களை தொடர்பு கொள்ளவும்",
      Login: "உள்நுழைய",

      "CSC Academy Establishment":
        "CSC அகாடமி 2017 ஆம் ஆண்டில் நிறுவப்பட்டது, இது பல்வேறு பின்னணிகள் மற்றும் கல்வி தேவைகளை கொண்ட மாணவர்களுக்கு தொழில்முறை கற்றலுக்கான அணுகலை வழங்குகிறது. CSC அகாடமி ஒரு இலாப நோக்கமற்ற அமைப்பாகும், இது சமூகம் பதிவு சட்டம் 1860 (சட்டம் 21, 1860) இன் கீழ் பதிவு செய்யப்பட்டுள்ளது, இது டெல்லி யூனியன் பிரதேசத்திற்கு பொருந்தும்.",
      "CSC Academy Programs & Funding":
        "CSC அகாடமி தற்போது இந்திய அரசு ஆதரவு வழங்கும் பல்வேறு திறன் மற்றும் கல்வி திட்டங்களை வழங்குகிறது, மேலும் தனியார் துறையிலும் பல்வேறு பாடநெறிகளை வழங்குகிறது. இதில் பல அரசு திட்டங்களோடு, கார்ப்பரேட் சமூக பொறுப்புணர்வு (CSR) நிதியளிப்பு மூலம் ஆதரிக்கப்படுகிறது.",
    },
  },
  or: {
    translation: {
      "Our Programs": "ଆମର କାର୍ଯ୍ୟକ୍ରମ",
      "Key Features": "ମୁଖ୍ୟ ବିଶେଷତା",
      "About Us": "ଆମ ବିଷୟରେ",
      "CSC-IIBF Training Program": "CSC-IIBF ଅଭିଯାନ ପ୍ରଶିକ୍ଷଣ କାର୍ଯ୍ୟକ୍ରମ",
      "Important Resources": "ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ସଂସାଧନଗୁଡ଼ିକ",
      "Candidate Login": "ପ୍ରାର୍ଥୀ ଲଗଇନ",
      Language: "ଭାଷା",
      "Empowering Future Banking Professionals":
        "ଭବିଷ୍ୟତ ବ୍ୟାଙ୍କିଂ ପେଶା ଜୀବୀଙ୍କୁ ଶକ୍ତିଶାଳୀ କରିବା",
      "DRA-For Graduates": "ସ୍ନାତକଙ୍କ ପାଇଁ DRA",
      "DRA-For Under Graduates": "ସ୍ନାତକ ପୂର୍ବ ଶିକ୍ଷାର୍ଥୀଙ୍କ ପାଇଁ DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) ପାଇଁ ବର୍ତ୍ତମାନ ନମିତ କରନ୍ତୁ",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) ପାଇଁ ବର୍ତ୍ତମାନ ନମିତ କରନ୍ତୁ",
      "Going Live in April": "ଏପ୍ରିଲ୍ ରୁ ଲାଇଭ୍ ହେଉଛି",
      "Course Duration": "ପାଠ୍ୟକ୍ରମ ଅବଧି",
      "100 hours": "100 ଘଣ୍ଟା",
      "50 hours": "50 ଘଣ୍ଟା",
      "Training Completion Certificate": "ପ୍ରଶିକ୍ଷଣ ସମାପ୍ତି ପ୍ରମାଣପତ୍ର",
      "How to Register?": "କିପରି ନମିତ ହେବେ?",
      "A Guide to DigiLocker": "DigiLocker ଗାଇଡ୍",
      "Prospectus - DRA Training (English)":
        "ପ୍ରସ୍ପେକ୍ଟସ୍ - DRA ପ୍ରଶିକ୍ଷଣ (ଇଂରାଜୀ)",
      "Prospectus - BC/BF Training (English)":
        "ପ୍ରସ୍ପେକ୍ଟସ୍ - BC/BF ପ୍ରଶିକ୍ଷଣ (ଇଂରାଜୀ)",
      "Advance Your Career":
        "DRA ଏବଂ ପ୍ରମାଣପତ୍ର ଦ୍ୱାରା ଆପଣଙ୍କର କାରିୟାର ଉନ୍ନତ କରନ୍ତୁ",

      "Training DRAs all over India": "ସମଗ୍ର ଭାରତରେ DRA ମାନଙ୍କ ପ୍ରଶିକ୍ଷଣ",
      "Empowering DRAs with skills and": "DRA ମାନଙ୍କୁ ଦକ୍ଷତା ଏବଂ",
      "knowledge in India": "ଭାରତରେ ଜ୍ଞାନ ଦେବା",
      "CAIIB-Certified Trainers": "CAIIB- ପ୍ରମାଣିତ ଟ୍ରେନର୍ମାନେ",
      "With over 20 years of rich experience in the":
        "20 ବର୍ଷରୁ ଅଧିକ ଅଭିଜ୍ଞତା ସହିତ",
      "banking sector, we bring trusted expertise.":
        "ବ୍ୟାଙ୍କିଂ କ୍ଷେତ୍ରରେ ଆମେ ନିଶ୍ଚିତ ବିଶ୍ୱସ୍ୟୋଗ୍ୟ ଜ୍ଞାନ ଅନେଇଛୁ।",

      "Providing comprehensive and seamless support to":
        "ସମ୍ପୂର୍ଣ୍ଣ ଏବଂ ସମର୍ଥନ ଯୋଗାଇବା",
      "ensure effective and impactful training experiences.":
        "ପ୍ରଭାବଶାଳୀ ଏବଂ ପ୍ରାଭାବୀ ଅଭିଜ୍ଞତା ସୁନିଶ୍ଚିତ କରିବା",

      "Advance Your Career with the DRA Certification Program":
        "DRA ପ୍ରମାଣନ ବ୍ୟବସ୍ଥାରେ ଆପଣଙ୍କ କାରିୟାର କୁ ଆଗେଇ ନେଇଯାଉ",
      "Advance Your Career Description":
        "CSC ର Debt Recovery Agent (DRA) ପ୍ରମାଣପତ୍ର ପ୍ରଗ୍ରାମ୍ ଆପଣଙ୍କୁ ଋଣ ପୁନର୍ପ୍ରାପ୍ତିରେ ବିଶେଷଜ୍ଞ ତିଆରି କରିବ। ଏହି ପ୍ରଗ୍ରାମ୍ ଆବଶ୍ୟକ ଦକ୍ଷତା, ଜ୍ଞାନ ଏବଂ ପ୍ରମାଣନ ପ୍ରଦାନ କରିଥାଏ, ଯେଉଁଥିରେ ଆପଣ ଧନୀୟ ସଂସ୍ଥାଗୁଡ଼ିକୁ ନୈତିକ ଏବଂ ଫଳପ୍ରଦ ଭାବରେ ପ୍ରତିନିଧିତ୍ୱ କରିପାରିବେ।",

      "Transform your business by becoming a certified BC/BF":
        "ପ୍ରମାଣିତ BC/BF ହୋଇ ଆପଣଙ୍କ ବ୍ୟବସାୟ କୁ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
      "Transform Your Business Description":
        "CSC ଅକାଦେମୀ ଏବଂ ଭାରତୀୟ ବ୍ୟାଙ୍କିଂ ଏବଂ ଆର୍ଥିକ ଅନୁଷ୍ଠାନ ଦ୍ୱାରା ମନ୍ୟତାପ୍ରାପ୍ତ BC/BF ପ୍ରମାଣପତ୍ର ଅଧିକ ଜ୍ଞାନ ଏବଂ ଦକ୍ଷତା ପ୍ରଦାନ କରିଥାଏ।",

      "Training Completion Description":
        "ଆମ ପ୍ରଶିକ୍ଷଣର ପ୍ରମାଣିତ ଅନୁଭବ ଉପରେ ଆଧାରିତ ପ୍ରମାଣପତ୍ର",

      "BC/BF Training - Basic Certification":
        "BC/BF ପ୍ରଶିକ୍ଷଣ - ମୌଳିକ ପ୍ରମାଣପତ୍ର",
      "BC/BF Training - Advanced Certification":
        "BC/BF ପ୍ରଶିକ୍ଷଣ - ଉନ୍ନତ ପ୍ରମାଣପତ୍ର",
      "28 hours": "28 ଘଣ୍ଟା",
      "42 hours": "42 ଘଣ୍ଟା",
      "Live Online Classes + Digital Content":
        "ଲାଇଭ୍ ଅନଲାଇନ୍ କ୍ଲାସ୍ + ଡିଜିଟାଲ୍ ସମଗ୍ରୀ",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "ଭାଷା: ଇଂରାଜୀ, ହିନ୍ଦୀ, ଗୁଜରାତୀ, ମରାଠୀ, ମାଲାୟାଲମ୍, କନ୍ନଡ, ଓଡିଆ, ବଙ୍ଗାଳୀ, ତାମିଲ୍, ତେଲୁଗୁ, ଅସମୀୟା",

      "Efficient Training Support": "ପ୍ରଭାବଶାଳୀ ପ୍ରଶିକ୍ଷଣ ସହାୟତା",

      "About CSC Academy": "CSC ଅକାଦେମୀ ବିଷୟରେ",
      "Download Important Resources": "ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ଅଧିକ ଜାଣିବା",
    },
  },
  pa: {
    translation: {
      "Our Programs": "ਸਾਡੇ ਪ੍ਰੋਗਰਾਮ",
      "Key Features": "ਮੁੱਖ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
      "About Us": "ਸਾਡੇ ਬਾਰੇ",
      "CSC-IIBF Training Program": "CSC-IIBF ਪ੍ਰਸ਼ਿਕਸ਼ਣ ਪ੍ਰੋਗਰਾਮ",
      "Important Resources": "ਅਹਿਮ ਸਰੋਤ",
      "Candidate Login": "ਉਮੀਦਵਾਰ ਲਾਗਿਨ",
      Language: "ਭਾਸ਼ਾ",
      "Empowering Future Banking Professionals":
        "ਭਵਿੱਖ ਦੇ ਬੈਂਕਿੰਗ ਪੇਸ਼ਾਵਰਾਂ ਨੂੰ ਸ਼ਕਤਸ਼ਾਲੀ ਬਣਾਉਣਾ",
      "DRA-For Graduates": "ਸਨਾਤਕਾਂ ਲਈ DRA",
      "DRA-For Under Graduates": "ਸਨਾਤਕ ਪੂਰਵ ਵਿਦਿਆਰਥੀਆਂ ਲਈ DRA",
      "Enroll Now for ₹5,000 + GST (18%)":
        "₹5,000 + GST (18%) ਲਈ ਹੁਣੇ ਹੀ ਦਰਜ ਕਰੋ",
      "Enroll Now for ₹6,000 + GST (18%)":
        "₹6,000 + GST (18%) ਲਈ ਹੁਣੇ ਹੀ ਦਰਜ ਕਰੋ",
      "Going Live in April": "ਅਪ੍ਰੈਲ ਵਿੱਚ ਲਾਈਵ ਜਾ ਰਿਹਾ ਹੈ",
      "Course Duration": "ਕੋਰਸ ਦੀ ਮਿਆਦ",
      "100 hours": "100 ਘੰਟੇ",
      "50 hours": "50 ਘੰਟੇ",
      "Training Completion Certificate": "ਪ੍ਰਸ਼ਿਕਸ਼ਣ ਪੂਰਾ ਹੋਣ ਦਾ ਸਰਟੀਫਿਕੇਟ",
      "How to Register?": "ਕਿਵੇਂ ਰਜਿਸਟਰ ਕਰਨਾ ਹੈ?",
      "A Guide to DigiLocker": "DigiLocker ਗਾਈਡ",
      "Prospectus - DRA Training (English)":
        "ਪਰੋਸਪੈਕਟਸ - DRA ਪ੍ਰਸ਼ਿਕਸ਼ਣ (ਅੰਗਰੇਜ਼ੀ)",
      "Prospectus - BC/BF Training (English)":
        "ਪਰੋਸਪੈਕਟਸ - BC/BF ਪ੍ਰਸ਼ਿਕਸ਼ਣ (ਅੰਗਰੇਜ਼ੀ)",
      "Advance Your Career":
        "DRA ਸਰਟੀਫਿਕੇਸ਼ਨ ਪ੍ਰੋਗਰਾਮ ਨਾਲ ਆਪਣੀ ਕਰੀਅਰ ਬਹੁਤਰੀ ਬਣਾਓ",

      "Training DRAs all over India": "ਭਾਰਤ ਭਰ ਵਿੱਚ DRA ਪ੍ਰਸ਼ਿਕਸ਼ਣ",
      "Empowering DRAs with skills and": "DRA ਨੂੰ ਹੁਨਰ ਅਤੇ",
      "knowledge in India": "ਭਾਰਤ ਵਿੱਚ ਗਿਆਨ ਦੇਣ",
      "CAIIB-Certified Trainers": "CAIIB-ਮਾਣਤਾ ਪ੍ਰਾਪਤ ਟ੍ਰੇਨਰ",
      "With over 20 years of rich experience in the":
        "20 ਸਾਲ ਤੋਂ ਵੱਧ ਦੇ ਵਧੀਆ ਤਜਰਬੇ ਨਾਲ",
      "banking sector, we bring trusted expertise.":
        "ਬੈਂਕਿੰਗ ਖੇਤਰ ਵਿੱਚ, ਅਸੀਂ ਵਿਸ਼ਵਾਸਯੋਗ ਮਾਹਿਰਤਾ ਲਿਆਉਂਦੇ ਹਾਂ।",

      "Providing comprehensive and seamless support to":
        "ਸੰਪੂਰਨ ਅਤੇ ਬਿਨਾ ਰੁਕਾਵਟ ਦੇ ਸਮਰਥਨ ਦੇਣਾ",
      "ensure effective and impactful training experiences.":
        "ਕਾਰਗੁਜ਼ਾਰੀ ਅਤੇ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਪ੍ਰਸ਼ਿਕਸ਼ਣ ਅਨੁਭਵ ਯਕੀਨੀ ਬਣਾਉਣਾ।",

      "Advance Your Career with the DRA Certification Program":
        "DRA ਸਰਟੀਫਿਕੇਸ਼ਨ ਪ੍ਰੋਗਰਾਮ ਨਾਲ ਆਪਣੀ ਕਰੀਅਰ ਬਹੁਤਰੀ ਬਣਾਓ",
      "Advance Your Career Description":
        "CSC ਦੇ Debt Recovery Agent (DRA) ਸਰਟੀਫਿਕੇਸ਼ਨ ਪ੍ਰੋਗਰਾਮ ਨਾਲ ਤੁਸੀਂ ਕਰਜ਼ਾ ਵਸੂਲੀ ਵਿੱਚ ਮਾਹਰ ਹੋ ਸਕਦੇ ਹੋ। ਇਹ ਪ੍ਰੋਗਰਾਮ ਤੁਹਾਨੂੰ ਲੋੜੀਂਦੇ ਹੁਨਰ, ਗਿਆਨ ਅਤੇ ਸਰਟੀਫਿਕੇਸ਼ਨ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ, ਜੋ ਤੁਹਾਨੂੰ ਵਿੱਤੀ ਸੰਸਥਾਵਾਂ ਦੀ ਅਮਾਨਦਾਰੀ ਅਤੇ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਤਰੀਕੇ ਨਾਲ ਨੁਮਾਇੰਦਗੀ ਕਰਨ ਵਿੱਚ ਸਹਾਇਕ ਬਣਾਉਂਦਾ ਹੈ।",

      "Transform your business by becoming a certified BC/BF":
        "ਇੱਕ ਪ੍ਰਮਾਣਿਤ BC/BF ਬਣ ਕੇ ਆਪਣਾ ਵਪਾਰ ਬਦਲੋ",
      "Transform Your Business Description":
        "CSC ਅਕਾਦਮੀ ਅਤੇ ਭਾਰਤੀ ਬੈਂਕਿੰਗ ਅਤੇ ਵਿੱਤੀ ਸੰਸਥਾ ਦੁਆਰਾ ਮੰਨਤਾ ਪ੍ਰਾਪਤ BC/BF ਸਰਟੀਫਿਕੇਸ਼ਨ ਪੂਰਾ ਕਰਕੇ, ਤੁਸੀਂ ਬੈਂਕਿੰਗ ਖੇਤਰ ਵਿੱਚ ਸਮਰਥ ਤਰੀਕੇ ਨਾਲ ਕੰਮ ਕਰ ਸਕਦੇ ਹੋ। ਇਹ ਸਰਟੀਫਿਕੇਸ਼ਨ ਤੁਹਾਨੂੰ ਬੈਂਕਿੰਗ ਨੁਮਾਇੰਦੇ ਵਜੋਂ ਕੰਮ ਕਰਨ ਲਈ ਲੋੜੀਂਦੇ ਗਿਆਨ ਅਤੇ ਹੁਨਰ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।",

      "Training Completion Description":
        "ਸਾਡੀ ਪ੍ਰਸ਼ਿਕਸ਼ਣ ਮੁਕੰਮਲ ਕਰਨ ਵਾਲੇ ਵਿਦਿਆਰਥੀਆਂ ਨੂੰ ਇਹ ਪ੍ਰਮਾਣਿਤ ਸਰਟੀਫਿਕੇਸ਼ਨ ਮਿਲਦਾ ਹੈ, ਜੋ ਉਨ੍ਹਾਂ ਦੀ ਵਿੱਤੀ ਸੰਸਥਾਵਾਂ ਵਿੱਚ ਪ੍ਰਵੇਸ਼ ਦੀ ਤਿਆਰੀ ਅਤੇ ਸਮਰੱਥਾ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ।",

      "BC/BF Training - Basic Certification":
        "BC/BF ਪ੍ਰਸ਼ਿਕਸ਼ਣ - ਬੇਸਿਕ ਸਰਟੀਫਿਕੇਸ਼ਨ",
      "BC/BF Training - Advanced Certification":
        "BC/BF ਪ੍ਰਸ਼ਿਕਸ਼ਣ - ਉੱਚ ਸਰਟੀਫਿਕੇਸ਼ਨ",
      "28 hours": "28 ਘੰਟੇ",
      "42 hours": "42 ਘੰਟੇ",
      "Live Online Classes + Digital Content":
        "ਲਾਈਵ ਆਨਲਾਈਨ ਕਲਾਸਾਂ + ਡਿਜ਼ੀਟਲ ਸਮੱਗਰੀ",

      "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese":
        "ਭਾਸ਼ਾ: ਅੰਗਰੇਜ਼ੀ, ਹਿੰਦੀ, ਗੁਜਰਾਤੀ, ਮਰਾਠੀ, ਮਲਿਆਲਮ, ਕਨੜ, ਓੜੀਆ, ਬੰਗਾਲੀ, ਤਮਿਲ, ਤੇਲੁਗੂ, ਅਸਾਮੀ",

      "Efficient Training Support": "ਕਾਰਗੁਜ਼ਾਰੀਯੋਗ ਪ੍ਰਸ਼ਿਕਸ਼ਣ ਸਮਰਥਨ",

      "About CSC Academy": "CSC ਅਕਾਦਮੀ ਬਾਰੇ",
      "Download Important Resources": "ਅਹਿਮ ਸਰੋਤ ਡਾਊਨਲੋਡ ਕਰੋ",
      "Download Important Resources Description":
        "ਆਪਣੀ ਸਰਟੀਫਿਕੇਸ਼ਨ ਯਾਤਰਾ ਲਈ ਲੋੜੀਂਦੇ ਦਸਤਾਵੇਜ਼ਾਂ ਤੱਕ ਪਹੁੰਚੋ।",
      "For Support, Contact Us": "ਸਮਰਥਨ ਲਈ, ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
      Login: "ਲਾਗਿਨ ਕਰੋ",

      "CSC Academy Establishment":
        "CSC ਅਕਾਦਮੀ 2017 ਵਿੱਚ ਸਥਾਪਿਤ ਕੀਤੀ ਗਈ, ਜੋ ਵੱਖ-ਵੱਖ ਪਿਛੋਕੜਾਂ ਅਤੇ ਸ਼ੈਖਣਕ ਲੋੜਾਂ ਵਾਲੇ ਵਿਦਿਆਰਥੀਆਂ ਨੂੰ ਵਿਅਵਸਾਇਕ ਸਿੱਖਣ ਦੀ ਪਹੁੰਚ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ। CSC ਅਕਾਦਮੀ ਇੱਕ ਗੈਰ-ਲਾਭਕਾਰੀ ਸੰਸਥਾ ਹੈ, ਜੋ ਸੋਸਾਇਟੀ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਐਕਟ 1860 (ਐਕਟ 21, 1860) ਦੇ ਅਧੀਨ ਰਜਿਸਟਰ ਕੀਤੀ ਗਈ ਹੈ, ਜੋ ਦਿੱਲੀ ਯੂਨੀਅਨ ਖੇਤਰ 'ਚ ਲਾਗੂ ਹੁੰਦੀ ਹੈ।",
      "CSC Academy Programs & Funding":
        "CSC ਅਕਾਦਮੀ ਹਾਲ ਵਿੱਚ ਭਾਰਤੀ ਸਰਕਾਰ ਦੁਆਰਾ ਆਯੋਜਿਤ ਵੱਖ-ਵੱਖ ਨਿਪੁੰਨਤਾ ਅਤੇ ਸਿੱਖਿਆ ਪ੍ਰੋਗਰਾਮ ਚਲਾ ਰਹੀ ਹੈ, ਅਤੇ ਨਿੱਜੀ ਖੇਤਰ ਲਈ ਵੀ ਕੋਰਸ ਪੇਸ਼ ਕਰ ਰਹੀ ਹੈ। ਇਨ੍ਹਾਂ ਵਿੱਚੋਂ ਬਹੁਤ ਸਾਰੇ ਸਰਕਾਰੀ ਯੋਜਨਾਵਾਂ ਜਾਂ ਕਾਰਪੋਰੇਟ ਸੋਸ਼ਲ ਰਿਸਪਾਂਸਬਿਲਿਟੀ (CSR) ਫੰਡਿੰਗ ਦੇ ਤਹਿਤ ਵਿੱਤ-ਸਹਿਯੋਗਤ ਹਨ।",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
